//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GovBanner from "~/components/GovBanner/GovBanner.vue";
import AccessibilityBanner from "~/components/AccessibilityBanner/AccessibilityBanner.vue";

export default {
  components: {
    GovBanner,
    AccessibilityBanner,
  },
};
